/**
 * Mixed-content guard (2026-09-22 "Not Secure" investigation): any URL that
 * came from CMS/Firestore data and is rendered as a src/href gets http://
 * upgraded to https:// defensively. Every host we serve media from
 * (firebasestorage, our own domains, YouTube) supports https; a stray http://
 * pasted into the CRM must never break the padlock. The CSP
 * upgrade-insecure-requests header is the browser-level backstop; this keeps
 * the markup itself clean (and covers legacy browsers).
 */
export function secureUrl(url: string): string;
export function secureUrl(url: string | undefined | null): string | undefined;
export function secureUrl(url: string | undefined | null): string | undefined {
  if (typeof url === 'string' && url.startsWith('http://')) {
    return 'https://' + url.slice(7);
  }
  return url ?? undefined;
}
